import { render, staticRenderFns } from "./taxi-course-general-info.vue?vue&type=template&id=6ed8eec2"
import script from "./taxi-course-general-info.vue?vue&type=script&lang=js"
export * from "./taxi-course-general-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports